The new state of the job ad to be created or updated.
